module.exports = __webpack_public_path__ + "static/img/code2.d702a13.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/code2.png
// module id = 2nCD
// module chunks = 41